import React from 'react'
import cn from 'classnames'
import styles from './NewPastImages.module.scss'
import PastImage from './PastImage'

export default function SixImageMarkup({ studentImages, backgroundUrl }) {
  return (
    <div className={cn(styles.imageContainer, styles.imageContainer6)}>
      <div className={styles.col}>
        <PastImage studentImage={studentImages[0]} backgroundUrl={backgroundUrl} />
      </div>
      <div className={styles.col}>
        {studentImages.slice(1, 5).map((studentImage) => (
          <PastImage studentImage={studentImage} backgroundUrl={backgroundUrl} />
        ))}
      </div>
      <div className={styles.col}>
        <PastImage studentImage={studentImages[5]} backgroundUrl={backgroundUrl} />
      </div>
    </div>
  )
}
